import React from 'react'
import { Paper, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const ThankYouActions = () => {
  return (
    <Paper>
      <div className="ThankYouComponent">
        <Accordion style={{ boxShadow: 'none' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            Contact the shopper
          </AccordionSummary>
          <AccordionDetails>
            coming soon
          </AccordionDetails>
        </Accordion>
        <Accordion style={{ boxShadow: 'none' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            Add a product to my order
          </AccordionSummary>
          <AccordionDetails>
            coming soon
          </AccordionDetails>
        </Accordion>
        <Accordion style={{ boxShadow: 'none' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            Remove a product from my order
          </AccordionSummary>
          <AccordionDetails>
            coming soon
          </AccordionDetails>
        </Accordion>
        <Accordion style={{ boxShadow: 'none' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4a-content"
            id="panel4a-header"
          >
            Download receipt in PDF
          </AccordionSummary>
          <AccordionDetails>
            coming soon
          </AccordionDetails>
        </Accordion>
      </div>
    </Paper >

  )
}

export default ThankYouActions